<template>
  <tr v-if="item">
    <td class="px-0 text-xs-center">
      <v-btn icon outline color="primary" @click.stop="goToLivechat(item.send_by_user_id)">
        <em class="fas fa-comments" />
      </v-btn>
    </td>
    <td class="py-2 px-2">
      <div>{{ item.drinker_name || '-' }}</div>
      <div>เบอร์โทร {{ item.filler_phone_no || '-' }}</div>
      <div>
        <span class="pr-2">อายุ {{ getAge(item.drinker_year) }}</span>
        <span>
          เพศ{{ item.drinker_gender ? (item.drinker_gender === 'male' ? 'ชาย' : 'หญิง') : '-' }}
        </span>
      </div>
      <div class="pt-1" style="position: relative; left: -6px">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              flat
              icon
              color="primary"
              class="ma-0"
              v-on="on"
              @click="selfReferralEditFormOpen = true"
            >
              <em class="fas fa-file-signature" style="font-size: 18px" />
            </v-btn>
          </template>
          <span>แก้ไขฟอร์ม</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              flat
              icon
              color="primary"
              class="ma-0"
              v-on="on"
              @click="previewDownloadDialogOpen = true"
            >
              <em class="fas fa-download" style="font-size: 18px" />
            </v-btn>
          </template>
          <span>ดาวน์โหลด</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn flat icon color="primary" class="ma-0" v-on="on" @click="handleDelete">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <span>ลบ</span>
        </v-tooltip>
      </div>
    </td>
    <td>{{ item.score || '-' }}</td>
    <td>
      <span v-if="item.risk === 'high'" class="error--text">ความเสี่ยงสูง</span>
      <span v-else-if="item.risk === 'medium'" class="warning--text">ความเสี่ยงปานกลาง</span>
      <span v-else-if="item.risk === 'low'" class="success--text">ความเสี่ยงต่ำ</span>
      <span v-else class="primary--text">ประเมินไม่ได้</span>
    </td>
    <td class="py-2">
      <v-select
        v-model="item.status"
        hide-details
        :items="statusOptions"
        outline
        item-text="label"
        item-value="value"
        solo
        flat
        style="width: 190px"
        placeholder="เลือกสถานะ"
        @change="handleUpdateStatus"
      />
    </td>
    <td>
      <EditNoteDialog :value="item.note" @onSaveNote="handleSaveNote" />
    </td>

    <v-dialog v-model="selfReferralEditFormOpen" width="950px" persistent scrollable>
      <SelfReferralFormDialog
        v-if="selfReferralEditFormOpen"
        :data="item"
        @close="selfReferralEditFormOpen = false"
        @onSaveForm="handleUpdateSelfReferral"
      />
    </v-dialog>

    <v-dialog v-model="previewDownloadDialogOpen" width="950px" persistent scrollable>
      <DownloadImageForm
        v-if="previewDownloadDialogOpen"
        :data="item"
        @close="previewDownloadDialogOpen = false"
      />
    </v-dialog>
  </tr>
</template>

<script>
import nongtungjaiApi from '@/api/nongtungjai'
import { mapGetters } from 'vuex'
import SelfReferralFormDialog from './SelfReferralFormDialog'
import EditNoteDialog from './EditNoteDialog'
import DownloadImageForm from './DownloadImageForm'

export default {
  components: {
    SelfReferralFormDialog,
    EditNoteDialog,
    DownloadImageForm
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      item: null,
      statusOptions: [
        {
          label: 'ยังไม่ได้ดำเนินการ',
          value: 'not_processed'
        },
        {
          label: 'รอติดต่อกลับ',
          value: 'waiting'
        },
        {
          label: 'ติดต่อแล้ว',
          value: 'contacted'
        }
      ],
      selfReferralEditFormOpen: false,
      fetchDownload: null,
      previewDownloadDialogOpen: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.item = this.value
      }
    }
  },
  mounted() {
    this.item = this.value
  },
  methods: {
    async handleSaveNote(value) {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const response = await vm.updateSelfReferral({
          id: vm.item.id,
          data: {
            page_id: vm.selectedBot.pageid,
            note: value
          }
        })
        vm.$store.dispatch('clear_loading')

        if (response && response.status === 200) {
          vm.item.note = value
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    async handleUpdateStatus() {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const response = await vm.updateSelfReferral({
          id: vm.item.id,
          data: {
            page_id: vm.selectedBot.pageid,
            status: vm.item.status
          }
        })
        vm.$store.dispatch('clear_loading')

        if (response && response.status === 200) {
          return
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    async handleUpdateSelfReferral(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.updateSelfReferral({
          id: vm.item.id,
          data: {
            page_id: vm.selectedBot.pageid,
            ...payload
          }
        })
        vm.$store.dispatch('clear_loading')

        if (response && response.status === 200) {
          vm.$emit('handleRefreshData')
          await vm.$swal.fire({
            type: 'success',
            text: 'สำเร็จ'
          })

          vm.selfReferralEditFormOpen = false
          vm.$emit('onRefetchData')
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    async updateSelfReferral(payload) {
      try {
        const response = await nongtungjaiApi.patchUpdateSelfReferral(payload)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async handleDelete() {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: this.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deleteSelfReferral()
          vm.$store.dispatch('clear_loading')
          if (response && response.status === 200) {
            await vm.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })

            vm.$emit('onRefetchData')
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    async deleteSelfReferral() {
      try {
        const response = await nongtungjaiApi.deleteSelfReferral({
          id: this.item.id,
          pageId: this.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    getAge(value) {
      const currentYear = new Date().getFullYear()
      const thaiYear = currentYear + 543
      const age = thaiYear - parseInt(value)
      return value ? age : '-'
    },
    goToLivechat: function (userId) {
      const routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: userId,
          user: 'admin',
          app: 'line'
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/DataItem.vue